{
  "version": 1,
  "asset_id": "6d2d6ce9-a1ec-4132-b53f-128161a02f7a",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/6d2d6ce9-a1ec-4132-b53f-128161a02f7a/rooms-family-units.jpg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/6d2d6ce9-a1ec-4132-b53f-128161a02f7a/rooms-family-units.jpg",
  "original_filename": "rooms-family-units.jpg",
  "size": 856942,
  "content_type": "image/jpeg",
  "created_at": "2026-07-02T22:36:24Z"
}
